import React, { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { editLicense, getUser, listCompanies, listLicenseTypes } from '../../services/service';
import MenuItem from '@mui/material/MenuItem';
import './ListPageStyles.css'
import { Box } from '@mui/material';
import { FormDialog } from '../FormDialog';
import { APISelectField } from '../APISelectField';
import { APITextField } from '../APITextField';
import { APICheckBoxField } from '../APICheckBoxField';



// const validationSchema = Yup.object({
//   name: Yup
//     .string('Insira o nome do Modelo da Licença')
//     .required('Campo obrigatório'),
//   durationUnit: Yup.string()
//     .oneOf(['lifetime', 'years', 'months', 'days'])
//     .required('Necessário escolher a unidade da duração!'),
// })

const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}

export default function EditLicense({ licenseData, sx, setOpenModal, openModal, onLicenseChanged }) {
  const [licenseTypesData, setLicenseTypesData] = useState(defaultResponse);
  const [companyData, setCompanyData] = useState(defaultResponse);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();

  const listLicenseTypesFn = useCallback(() => {
    setLoading(true);
    listLicenseTypes(1, 1000)
      .then((response) => {
        setLicenseTypesData(response.data)
      })
      .catch((error) => {
        // TODO: Add an alert notifying the user about this error.
        console.log(error)
      })
      .finally(setLoading(false))
  }, [])

  const getCompanyFn = useCallback(() => {
    setLoading(true);
    listCompanies(1, 1000)
      .then((response) => {
        setCompanyData(response.data)
      })
      .catch((error) => {
        getUser({ expand: "company" }).then((res) => {

          setCompanyData({ results: [res.data["company"]] })
        }).catch((error) => {
          console.log(error)
        }).finally(setLoading(false))
      })
      .finally(setLoading(false))
  }, [])


  useEffect(() => {
    listLicenseTypesFn()
    getCompanyFn()
  }, [loading])

  const handleClose = () => {
    setOpenModal(false);
  };

  const formik = useFormik({
    initialValues: {
      company: licenseData.company_id,
      license_type: licenseData.license_type_id,
      description: licenseData.description,
      is_server_type: licenseData.is_server_type,
    },
    enableReinitialize: true,
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      var payload = {
        company: formik.values.company,
        description: formik.values.description,
        license_type: formik.values.license_type,
        is_server_type: formik.values.is_server_type,
      }

      editLicense(
        licenseData.id, payload
      ).then((response) => {
        console.log(response['status'])
        if (response.status === 200) {
          handleClose()
          onLicenseChanged()
          formik.resetForm()
        } else {
          console.log(response.data)
        }
      }).catch((err) => {
        setErrors(err.response.data);
      }).finally((resp) => {
        setLoading(false)
      })
    }
  })

  return (
    <Box sx={sx}>
      <FormDialog
        title={"Editar licença"}
        open={openModal}
        onDismiss={handleClose}
        onSubmit={formik.handleSubmit}
        formWidth={500}
        loading={loading}
      >
        <APISelectField
          id="license-company"
          name="company"
          label={"Empresa"}
          style={{ width: "100%" }}
          value={formik.values.company}
          onChange={formik.handleChange}
          disabled={loading}
          errors={errors?.company}
        >
          {companyData.results.map(company => (
            <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
          ))}
        </APISelectField>
        <APITextField
          id="license-type-description"
          label="Descrição"
          name="description"
          multiline
          disabled={loading}
          value={formik.values.description}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.description}
        // style={{ width: "100%", margin: '1rem 0rem' }}
        />
        <APISelectField
          id="license-type"
          name="license_type"
          label="Modelo de Licença"
          // style={{ width: "100%" }}
          value={formik.values.license_type}
          onChange={formik.handleChange}
          disabled={loading}
          errors={errors?.license_type}
        >
          {licenseTypesData.results.map(licenseType => (
            <MenuItem
              value={licenseType.id}
              key={licenseType.id}
              style={{ justifyContent: "space-between" }}
            >
              {licenseType.name}
            </MenuItem>
          ))}
        </APISelectField>
        <APICheckBoxField
          id={"is_server_type"}
          name={"is_server_type"}
          label={"Servidor de Licenças"}
          value={formik.values.is_server_type}
          onChange={formik.handleChange}
          disabled={loading}
          errors={errors?.is_server_type}
        />
      </FormDialog>
    </Box >
  );
}
